// extracted by mini-css-extract-plugin
module.exports = {"items":"vouchers_items__DwHzq","item":"vouchers_item__pH2ph"};